import React from 'react';
import { Modal, Spin } from 'antd';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';
import { proxy } from 'yxyweb/common/helpers/util';


export default class TextDiff extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            id: props.id,
            oldValue: "",
            newValue: ""
        };
    }
    componentDidMount() {
        let _this =  this;
        const config = {
            url: '/bill/bizlog/' + _this.state.id,
            method: 'GET'
        }
        _this.setState({loading : false})
        proxy(config).then(json => {
            _this.state.loading = false;
            if (json.code !== 200) return;
            _this.setState(
                {
                    oldValue : json.data.originData, 
                    newValue: json.data.finalData 
                })
        })
    }

    handleOk = (e) => {
        this.props.close()
    }
    
    render() {
        return (
            <Modal
              visible={true}
              title='数据差异'
              width='1200'
              height='1000'
              footer={null}
              onCancel={this.handleOk}
            >
                <Spin spinning={this.state.loading}>
                 <ReactDiffViewer leftTitle="修改前" rightTitle="修改后" oldValue={this.state.oldValue} newValue={this.state.newValue} compareMethod={DiffMethod.WORDS} disableWordDiff={true} splitView={true} />
                </Spin>
                <div className="ant-modal-footer" style={{borderTop:'none',"paddingRight":10,"paddingBottom":10}}>
                   <button type="button" className="ant-btn ant-btn-primary ant-btn-lg" onClick={this.handleOk.bind(this)}><span>关 闭</span></button>
                 </div>
          </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/modal/TextDiff.jsx